import { ComboBox, IComboBoxOption, mergeStyles, Stack, TextField } from '@fluentui/react';
import { useEffect, useState } from 'react';

import { popup } from '../../../../addons/Popup';
import { useAppSelector } from '../../../../App/store';
import taxAdmins from '../../../../shared/tax-admins.json';
import { getAsync } from '../../../../utils/api';
import { actions } from '../../slice';

type Props = {};

export default (props: Props) => {
  const taxId: string =
    useAppSelector(
      (state) => state.accounts.accountVariables.citizenIdNumber
    ) || "";
  const taxAdminId: string =
    useAppSelector((state) => state.accounts.accountVariables.taxAdminId) || "";
  const companyName: string =
    useAppSelector((state) => state.accounts.accountVariables.companyName) ||
    "";
  const disabled = taxId.length !== 10;

  useEffect(() => {
    if (disabled) return;
    if (!taxId || !taxAdminId) return;

    actions.setAccountVariable(["companyName", ""]);

    getAsync(`/accounts/get-tax-info?id=${taxId}&adminId=${taxAdminId}`)
      .then((res) => {
        if (!res.success) throw new Error(res.message);

        if (res.data.status === "FAAL") {
          actions.setAccountVariable(["companyName", res.data.name]);
        } else {
          popup(`Şirket durumu faal değil (${res.data.name})`);
        }
      })
      .catch((err) => {
        console.error(err);
        popup("Vergi bilgileri alınırken hata oluştu\nHATA: " + err.toString());
      });
  }, [disabled, taxId, taxAdminId]);

  return (
    <Stack horizontal tokens={{ childrenGap: 15 }}>
      <Stack.Item className={itemStyles}>
        <ComboBox
          className={inputStyles}
          disabled={disabled}
          options={taxAdminOptions}
          selectedKey={taxAdminId}
          onChange={(_, option) =>
            actions.setAccountVariable(["taxAdminId", option?.key])
          }
          label="Vergi Dairesi"
          autoComplete="on"
          allowFreeform
        />
      </Stack.Item>

      <Stack.Item className={itemStyles}>
        <TextField
          label="Şirket Ünvanı"
          value={companyName || ""}
          disabled={disabled}
          readOnly
        />
      </Stack.Item>
    </Stack>
  );
};

const taxAdminOptions: IComboBoxOption[] = taxAdmins.map((info) => ({
  key: info.id,
  text: info.name,
  data: info,
}));
const itemStyles = mergeStyles({
  width: "50%",
});
const inputStyles = mergeStyles({
  width: "100%",
});
